/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliActivityGradeDto } from '../../models/amoxcalli-activity-grade-dto';

export interface ApiGradesActivityGet$Json$Params {
  cycleSubjectId?: string;
  periodId?: string;
  groupId?: string;
}

export function apiGradesActivityGet$Json(http: HttpClient, rootUrl: string, params?: ApiGradesActivityGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliActivityGradeDto>>> {
  const rb = new RequestBuilder(rootUrl, apiGradesActivityGet$Json.PATH, 'get');
  if (params) {
    rb.query('cycleSubjectId', params.cycleSubjectId, {});
    rb.query('periodId', params.periodId, {});
    rb.query('groupId', params.groupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliActivityGradeDto>>;
    })
  );
}

apiGradesActivityGet$Json.PATH = '/api/grades/activity';
